<template>
  <div id="app">
    <my-header></my-header>
    <div style="padding-top: 90px; min-height: 650px; min-width: 1500px; background: #fafafa;">
    <router-view/>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import myHeader from './components/common/header'
import myFooter from './components/common/footer'
export default {
  data(){
    return {

    }
  },
  methods:{

  },
  components: {
    myHeader,
    myFooter
  },
}
</script>

<style>
img{
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/App.vue